import React from 'react';

const Card = ({ name, email, id }) => {
  return (
    <div className='tc grow bg-light-green br3 pa3 ma2 dib bw2 shadow-5'>
      <img alt='robots' src={`https://robohash.org/${id}?200x200`} />
      <div>
        <h1>ID: {id}</h1>
        <h2>Name: {name}</h2>
        <p>EMAIL: {email}</p>
      </div>
    </div>
  );
}

export default Card;